<script setup lang="ts">
import RatingEmoji from './RatingEmoji.vue';
import { digidooSocialMediaViewLinks as socialMediaLinks } from '@/utils/social-media.utils';
</script>

<template>
  <div class="flex flex-col gap-xl text-center">
    <RatingEmoji :level="5" class="w-[80px] h-[80px] mx-auto" />
    <h1 class="text-title leading-[36px] font-medium">
      {{ $t('help.rating.final') }}
    </h1>

    <div class="flex w-full flex-col gap-md">
      <a
        v-for="link in socialMediaLinks"
        :key="link.key"
        :href="link.url"
        :title="$t(link.labelKey)"
        target="_blank"
        rel="noopener noreferrer"
        class="flex h-button min-h-button w-full items-center justify-center gap-sm rounded-button border border-divider bg-white px-md text-body font-semibold leading-[170%] text-primary state-effects hover:bg-tint/10"
      >
        <img :src="link.iconPath" alt="" aria-hidden="true" class="size-icon shrink-0" />
        <span>{{ $t(link.labelKey) }}</span>
      </a>
    </div>
  </div>
</template>
